<div class="tooltip">
    <div>
		@if (iconSVG()) {
			<img [src]="'assets/image/' + iconSVG()"
				 alt=""
				 [attr.aria-labelledby]="randomUUIDForHeader + ' ' + randomUUIDForBody">
		}
		@if (hmfIcon()) {
			<homefield-icon
				class="hyperlink info-icon hmf-display-inline-flex"
				width="18px"
				height="18px"
				[name]="hmfIcon()"
				fill="var(--hmf-gray700)">
			</homefield-icon>
		}
    </div>
    <span class="tooltiptext showOnHover" #textElement>
		<div>
			@if (textHeader()) {
				<b [id]="randomUUIDForHeader">
						{{textHeader()}}
				</b>
				<br>
			}
			<p class="hmf-mt-0"
			   [id]="randomUUIDForBody"
			   [innerHtml]="textBody() | bypassSanitization">
			</p>
		</div>
    </span>
</div>
